import type { ICreateProfile } from 'blocks/CreateProfile/index.h'

import { ButtonIconSizes, IconPositions } from 'atoms/Button'
import { IconNames } from 'atoms/Icon'
import { TextBoxMaxLine2Font2XlBold } from 'atoms/TextBox/Templates'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import {
  BackButtonSC,
  CreateProfileFormSC,
  CreateProfileSC,
} from './CreateProfile.styled'

export const CreateProfile = ({ children, title, onBack }: ICreateProfile) => {
  return (
    <CreateProfileSC>
      {onBack && (
        <BackButtonSC
          icon={IconNames.arrowLeft}
          iconPosition={IconPositions.Center}
          iconSize={ButtonIconSizes.xSm}
          paddings={[
            FIXED_INDENTS.INDENT_30,
            FIXED_INDENTS.INDENT_30,
            FIXED_INDENTS.INDENT_30,
            FIXED_INDENTS.INDENT_30,
          ]}
          onClick={onBack}
        />
      )}
      <CreateProfileFormSC>
        <TextBoxMaxLine2Font2XlBold title={title} />
        {children}
      </CreateProfileFormSC>
    </CreateProfileSC>
  )
}
